/* eslint-disable import/no-unused-modules */
import React, { useEffect } from 'react';

import { makeNamespacedComponent } from '@/ui/utils';
import { RootStyled } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/variants/styles';
import { WeeklyLearningLoop } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/types';
import {
  LoadingState,
  WeeksNavigationHeader,
  WeeksPagination,
  WeeksTabNavigation,
} from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/atoms';
import { useWeekNavigationsContext } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/context';

export type WeeksSetupProps = {
  weeks: WeeklyLearningLoop[];
  selectedWeek: WeeklyLearningLoop | null;
  maxVisibleWeeksCount?: number;
  onChangeSelectedWeek: (weekNumber: number) => void;
  onHelpClick: () => void;
};

const WeeksSetupBase = ({
  weeks,
  maxVisibleWeeksCount = 4,
  selectedWeek,
  onChangeSelectedWeek,
  onHelpClick,
}: WeeksSetupProps): JSX.Element => {
  const { setWeeks, setMaxVisibleWeeksCount, setSelectedWeek, triggeredPagination, shownWeeks } = useWeekNavigationsContext();

  useEffect(() => {
    setWeeks(weeks);
    setMaxVisibleWeeksCount(maxVisibleWeeksCount);
    setSelectedWeek(selectedWeek);
  }, [weeks, maxVisibleWeeksCount, selectedWeek]);

  const isSelectedWeekVisible = shownWeeks.map(({ id }) => id).includes(selectedWeek?.id || '');

  if (!triggeredPagination && !isSelectedWeekVisible) {
    return <LoadingState />;
  }

  return (
    <RootStyled>
      <WeeksNavigationHeader onHelpClick={onHelpClick} />
      <WeeksPagination>
        <WeeksTabNavigation onChangeSelectedWeek={onChangeSelectedWeek} />
      </WeeksPagination>
    </RootStyled>
  );
};

export const WeeksSetup = makeNamespacedComponent(WeeksSetupBase, {
  LoadingState,
});
